import * as types from './types';
import { loading } from 'State/actions';

export const getSiteDetails = siteId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SITESETUP_SITE_DETAILS_FETCHING, true));
    try {
      const siteResponse = await MPWWebApi.getGeneric(`sitemaster/${siteId}`);
      const calResponse = await MPWWebApi.getGeneric(
        `SchoolCalendar/BySite/${siteId}`
      );

      const warehousesKitchesCallResponse = await MPWWebApi.getGeneric(
        `InvSiteWarehouse/GetAssignedSiteWarehouse/${siteId}`
      );

      dispatch({
        type: types.SITESETUP_GET_SITE_DETAILS,
        payload: {
          data: siteResponse.data,
          calendar: calResponse.data.Data,
          warehousesAndKitchens: warehousesKitchesCallResponse.data.Data,
        },
      });
    } catch (error) {
      dispatch({
        type: types.SITESETUP_GET_SITE_DETAILS_ERROR,
        payload: error.response,
      });
    }
    dispatch(loading(types.SITESETUP_SITE_DETAILS_FETCHING, false));
  };
};

export const clearSiteDetails = value => {
  return {
    type: types.SITESETUP_CLEAR_SITE_DETAILS,
    payload: value,
  };
};

export const updateSiteDetails = value => {
  return {
    type: types.SITESETUP_UPDATE_SITE_DETAILS,
    payload: value,
  };
};
export const getStorageLocations = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      const storageLocationResponse = await MPWWebApi.getGeneric(
        `InvGroup/GetStorageLocations`
      );

      dispatch({
        type: types.GET_STORAGE_LOCATION,
        payload: storageLocationResponse.data.Data,
      });
    } catch (error) {
      dispatch({
        type: types.SITESETUP_GET_SITE_DETAILS_ERROR,
        payload: error.response,
      });
    }
  };
};
export const getHandlingFeeList = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      const handlingFeeList = await MPWWebApi.getGeneric(
        `InvVendors/GetHandlingVendors`
      );

      dispatch({
        type: types.GET_HANDLING_FEE,
        payload: handlingFeeList.data.Data,
      });
    } catch (error) {
      dispatch({
        type: types.SITESETUP_GET_SITE_DETAILS_ERROR,
        payload: error.response,
      });
    }
  };
};



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/siteDetails/actions.js